<template>
  <div class="root">
    <el-menu
      :default-active="$route.path"
      router
      background-color="black"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-menu-item index="/console/announcement/edit">
        <i class="el-icon-mic"></i>
        <span slot="title">公告</span>
      </el-menu-item>
      <el-menu-item index="/console/mail/templateList">
        <i class="el-icon-message"></i>
        <span slot="title">邮件</span>
      </el-menu-item>
      <el-menu-item index="/console/redeem-code">
        <i class="el-icon-present"></i>
        <span slot="title">兑换码</span>
      </el-menu-item>
      <el-menu-item index="/console/misc/qqgroups">
        <i class="el-icon-chat-dot-square"></i>
        <span slot="title">QQ群</span>
      </el-menu-item>
      <el-menu-item
        index="/console/cloudArchive/recover"
        v-if="!disableCloudArchive"
      >
        <i class="el-icon-sort"></i>
        <span slot="title">云存档</span>
      </el-menu-item>
      <el-menu-item index="/console/misc/blacklist">
        <i class="el-icon-document-delete"></i>
        <span slot="title">黑名单</span>
      </el-menu-item>
      <el-menu-item index="/console/misc/greylist">
        <i class="el-icon-notebook-2"></i>
        <span slot="title">灰名单</span>
      </el-menu-item>
      <el-menu-item index="/console/misc/whitelist">
        <i class="el-icon-document-checked"></i>
        <span slot="title">白名单</span>
      </el-menu-item>
      <el-menu-item index="/console/misc/clientlog">
        <i class="el-icon-video-camera"></i>
        <span slot="title">日志</span>
      </el-menu-item>
      <el-menu-item index="/console/misc/sensitivewords">
        <i class="el-icon-warning-outline"></i>
        <span slot="title">敏感词</span>
      </el-menu-item>
      <el-menu-item index="/console/picture">
        <i class="el-icon-picture"></i>
        <span slot="title">图片</span>
      </el-menu-item>
      <el-menu-item index="/console/function-switch/list">
        <i class="el-icon-switch-button"></i>
        <span slot="title">功能开关</span>
      </el-menu-item>
      <el-menu-item index="/console/version/list">
        <i class="el-icon-s-flag"></i>
        <span slot="title">版本管理</span>
      </el-menu-item>
      <el-menu-item index="/console/zone/list" v-if="isZonal">
        <i class="el-icon-s-grid"></i>
        <span slot="title">分区</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import store from "@/store";

export default {
  data() {
    return {
      disableCloudArchive: store.projectInfo.disableCloudArchive, // 这个用于决定是否隐藏掉后台的"云存档"菜单项
      isZonal: store.projectInfo.isZonal, // 是否支持分区模式（即网游那样的滚服模式）
    };
  },
};
</script>

<style lang="scss" scoped>
.root {
  background-color: black;
  width: 300px;
  position: fixed;
  bottom: 0px;
}

.el-menu {
  border-right: 0px;
  padding-top: 15px;
}

.el-submenu,
.el-menu-item {
  text-align: left;
}

.el-submenu .el-menu-item {
  margin-left: 20px;
}
</style>